import React from 'react';

const jQuery_Selectors = () => {
  return (
    <div >
      <h1>jQuery_Selectors</h1>
      <p>Placeholder component for: "jQuery Selectors"</p>
    </div>
  );
};

export default jQuery_Selectors;
